const Achievements = {
    RANKING: 'Ranking',
    HISTORIC_RANKING: 'Historic Ranking',
  };
  
  export default Achievements;